import { Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { cardInnerSx } from '../hero/styles';

/**
 * The full-page grid of cards.
 */
export default function CardGridBody({
  items, renderCard, lgSpan, rowCap,
}) {
  return (
    <Grid
      spacing={2}
      container
      sx={{
        margin: 0,
        marginLeft: '-16px',
        width: 'calc(100% + 16px)',
        height: '100%',
        alignContent: 'center',
        justifyContent: 'center',
        '& > .MuiGrid-item': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          containerType: 'size',
          minHeight: 0,
          maxHeight: rowCap,
        },
      }}
    >
      {items.map((entity) => (
        <Grid
          key={entity.id}
          xs={lgSpan}
          item
          sx={{ width: '100%', aspectRatio: '1 / 1' }}
        >
          <Box sx={cardInnerSx}>{renderCard(entity)}</Box>
        </Grid>
      ))}
    </Grid>
  );
}

CardGridBody.propTypes = {
  items: PropTypes.array.isRequired,
  renderCard: PropTypes.func.isRequired,
  lgSpan: PropTypes.number.isRequired,
  rowCap: PropTypes.string.isRequired,
};
